import { render } from "./WalletLegacyPanel.vue?vue&type=template&id=2ed2bdf0&scoped=true"
import script from "./WalletLegacyPanel.vue?vue&type=script&lang=ts"
export * from "./WalletLegacyPanel.vue?vue&type=script&lang=ts"

import "./WalletLegacyPanel.vue?vue&type=style&index=0&id=2ed2bdf0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ed2bdf0"

export default script